// extracted by mini-css-extract-plugin
module.exports = {"popupBox":"walletsPopup_popupBox__3mjJr","box":"walletsPopup_box__34rq9","close":"walletsPopup_close__Jm94k"};